<template>
  <div v-if="components.length === 0" class="not-exist">
    <div v-if="isViewPc">
      <img src="@/assets/images/qs_pc.png" alt="">
      <p>电脑端未配置内容，请用手机打开</p>
    </div>
    <div v-else>
      <img src="@/assets/images/qs_gzh.png" alt="">
      <p>手机端未配置内容，请用电脑打开</p>
    </div>
  </div>
  <div v-else class="page"
    :class="{'pc-wap': isPcWapView}"
    :style="pageStyle">
    <Loader
      v-for="cmp in components"
      :key="cmp.domId"
      :vueName="cmp.type"
      :component="cmp"
      preview />
    <Loader
      v-for="cmp in suspComps"
      :key="cmp.domId"
      :vueName="cmp.type"
      :component="cmp"
      preview />
    <div
      v-for="cmp in floorNavComps"
      :key="cmp.domId"
      class="floor-nav-item">
      <Loader
        :vueName="cmp.type"
        :component="cmp"
        preview />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import utils from '@/utils/util'
import { mobilecheck } from '@/utils/ua'
import Loader from '@/components/asyncComponent'
export default {
  name: 'Main',
  components: {
    Loader
  },
  computed: {
    ...mapState('editor', ['pageSet', 'components', 'suspComps', 'head', 'floorNavComps']),
    keywords () {
      if (this.head && this.head.tdk) {
        return this.head.tdk + ',免费模板'
      }
      return '易企秀-免费H5页面制作工具-微信H5页面,微信朋友圈会议邀请函,电子贺卡,动态音乐相册,电子微杂志,节日贺卡等,易企秀提供海量H5微场景模板,轻松制作一键生成H5页面,为您助力移动自营销,酷炫展示H5企业自营销页面-易企秀官网'
    },
    description () {
      if (this.head && this.head.keyword) {
        return this.head.keyword + '-易企秀，人人会用的创意设计平台'
      }
      return ''
    },
    pageStyle () {
      return utils.styleArrayToStyle(this.pageSet.moduleContent.style)
    },
    // pc模式预览移动样式
    isPcWapView () {
      let _platform = Number(topicParams._platform || 1)
      const innerview = topicParams.innerview
      return _platform !== 1 && !innerview && !mobilecheck()
    },
    // 预览的是pc还是移动
    isViewPc () {
      let _platform = Number(topicParams._platform || 1)
      return _platform === 1
    }
  },
  head: {
    title () {
      return {
        inner: this.head.name
      }
    },
    meta () {
      return [
        { name: 'description', content: this.description },
        { name: 'keywords', content: this.keywords }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.not-exist {
  background-color: #F5F8FF;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  line-height: 20px;
  color: #999;
  text-align: center;
  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  img {
    width: 220px;
  }
  p {
    margin-top: 16px;
  }
}

.page {
  padding-bottom: 1px;
  &.pc-wap {
    width: 375px;
    height: 667px;
    overflow: auto;
    box-shadow: 0 0 2px #999;
    margin: 40px auto 0;
    border-radius: 4px;
  }
  &.pc-wap::-webkit-scrollbar {
    width : 1px;
  }
}

.floor-nav-item {
  width: 70px;
  position: fixed;
  top: 50%;
  left: 0;
  z-index: 100;
  transform: translate(0,-50%);
}
</style>
